module.exports = __webpack_public_path__ + "static/media/wellbeing-foundations-large.b4b58aea.png";